module.exports = __webpack_public_path__ + "static/media/ico_american-express.d5fd7058.svg";